import { Plugin } from "@ckeditor/ckeditor5-core";
import { InsightsBlockPromptConversion } from "./plugins/InsightsBlockPromptConversion.plugin";

export class InsightsBlockPromptWidgets extends Plugin {
  static get requires() {
    return [InsightsBlockPromptConversion];
  }
}
